export default __webpack_public_path__ + "static/media/img_7.179f531f.JPG";